// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IAllocatedDeviceKeyResult {
	id: string | undefined;

	deviceKey: string | undefined;

	dateAllocated: string | undefined;

	name: string | undefined;

	$type?: string | undefined;
}
export class AllocatedDeviceKeyResult {
	constructor(data?: IAllocatedDeviceKeyResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.dateAllocated) { this.dateAllocated = new Date(data.dateAllocated); }
	}

	id: string | undefined;

	deviceKey: string | undefined;

	dateAllocated: Date | undefined;

	name: string | undefined;

	static $type: string = "CoreApi.Models.AllocatedDeviceKeyResult, ";
	$type?: string | undefined = AllocatedDeviceKeyResult.$type;
}

